import { connect } from "react-redux";
import ReportShiftLog from "../components/Report/ShiftLog";

const ReportShiftLogPage = ({ accessToken, currentLang }) => {
  return (
    <ReportShiftLog accessToken={accessToken} currentLang={currentLang} />
  );
};

function mapStateToProps({ auth, lang }) {
  return {
    auth,
    accessToken: auth.token.accessToken,
    currentLang: lang.currentLang,
  };
}

export default connect(mapStateToProps, null)(ReportShiftLogPage);
